import { defineMessages } from 'react-intl';
export default defineMessages({
  includedCertsTitle: {
    id: "BundleCertDetails.includedCertsTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Certificates that are included in the "
    }, {
      "type": 1,
      "value": "certName"
    }, {
      "type": 0,
      "value": " certificate summary:"
    }]
  },
  certsFilesTitle: {
    id: "BundleCertDetails.certsFilesTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Attached files to the certificate:"
    }]
  },
  certItem: {
    id: "BundleCertDetails.certItem",
    defaultMessage: [{
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 1,
      "value": "supervisorOrganization"
    }, {
      "type": 0,
      "value": " "
    }, {
      "type": 1,
      "value": "supervisor"
    }, {
      "type": 0,
      "value": ", certificate no "
    }, {
      "type": 1,
      "value": "code"
    }]
  }
});